export const apiCallbacks = {}

export const registerCallback = (requestId, callback) => {
    apiCallbacks[requestId] = callback
}

export const unregisterCallback = (requestId) => {
    delete apiCallbacks[requestId]
}

// Android와 iOS에 메시지를 전송하는 함수
export const sendMessageToNativeApp = (methodName, data) => {
    if (methodName === "handleLog") {
        console.log(JSON.stringify(data))
    }

    const jsonString = JSON.stringify(data)

    // Android와 통신
    if (methodName !== "handleLog" && window.Android) {
        window.Android[methodName](jsonString)
    }

    // iOS와 통신
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[methodName]) {
        window.webkit.messageHandlers[methodName].postMessage(jsonString)
    }
}

// API 요청을 보내는 메서드
export const sendApiRequest = (request) => {
    try {
        console.log(request)
        const requestId = generateRequestId()

        request.requestId = requestId
        apiCallbacks[requestId] = request.callback

        sendMessageToNativeApp("sendApiRequest", request)
    } catch (error) {
        console.log(error)
    }
}

// requestId를 생성하는 메서드
export const generateRequestId = () => {
    const timestamp = Date.now()
    const randomPart = Math.random().toString(36).substring(2, 15)

    return `${timestamp}-${randomPart}`
}

// API 응답을 처리하는 메서드
export const getApiResponse = (event) => {
    try {
        const { requestId, data } = event

        if (!requestId) {
            return
        }

        // 해당 ID에 대한 콜백 함수가 있는지 확인하고 호출
        const callback = apiCallbacks[requestId]
        if (callback) {
            callback(data)
            delete apiCallbacks[requestId] // 호출 후 삭제
        }
    } catch (error) {
        sendMessageToNativeApp("handleLog", {
            message: "getApiResponseError",
            data: JSON.stringify(error),
        })
    }
}